import React, { Component } from "react";
import EmailSignupBusiness from "../components/EmailSignupBusiness";
import DesktopHeader from "../components/DesktopHeader";
import MobileHeader from "../components/MobileHeader";
import HowItWorks from "../components/HowItWorks";
import { Card } from "@material-ui/core";
import Offer from "../assets/Offer.svg";
import Chat from "../assets/Chat.svg";
import Rewards from "../assets/Rewards.svg";
import DashboardFull from "../assets/DashboardFull.svg";
import "./Business.css";

class Business extends Component {

  render() {
    console.log(`Window width: ${this.props.width}`)
    return (
      <div
        className="business-container"
        style={{
          height: "100%",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          fontFamily: "Raleway"
        }}
      >
      {window.innerWidth >768?  <DesktopHeader />: <MobileHeader/>}
       
        <div
          className="fixed-row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "space-between",
            width: "100%",
            fontFamily: "Raleway",
            padding: "15% 5% 0% 5%",
            zIndex: 0
          }}
        >
          <div
            className="col"
            style={{
              color: "white",
              display: "flex",
              flexWrap: "wrap",
              flexGrow: 1,
              textAlign: "left",
              width: "80%"
            }}
          >
            <p
              className="headline"
              style={{
                position: "fixed",
                width: "70%",
                fontWeight: 500,
                fontSize: 38
              }}
            >
              Build a Kinder workplace and <br/>help your employees thrive.
            </p>

            <p
              className="headline-sub"
              style={{
                marginTop: "10%",
                position: "fixed",
                width: "40%",
                fontWeight: 100,
                fontSize: 24,
                color: "#CCCCCC"
              }}
            >
              We are a time-sharing platform that helps employees balance work
              and life while building stronger community with their teammates.
            </p>
          </div>

          <div className="col" style={{ justifyContent: "center" }}>
            <object
              className="dashboard-full"
              data={DashboardFull}
              type="image/svg+xml"
              style={{
                zIndex: -10,
                marginTop: "0%",
                marginLeft: "-45%",
                position: "fixed",
                overflow: "hidden",
                width: "1000px",
                boxShadow: "2px black",
                borderRadius: "4px"
              }}
            />
          </div>
        </div>

        <div
          className="row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            width: "100%",
            fontFamily: "Raleway",
            padding: "2% 5% 35% 5%"
          }}
        >
          <div
            className="col"
            style={{ position: "fixed", marginTop: "15%", zIndex: -10 }}
          >
            <EmailSignupBusiness style={{}} />
          </div>
        </div>
        <HowItWorks />
        <div
          className="benefits-row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            fontFamily: "Raleway",
            backgroundColor: "#F5F5F5",
            paddingBottom: "5%"
          }}
        >
          <Card className="benefits-card" style={{}}>
            <Card
              className="col1"
              style={{
                padding: "2% 2% 2% 2%",
                backgroundColor: "rgba(12, 80, 135,.9)",
                borderRadius: "14px",
                maxWidth: "400px",
              }}
            >
              <p
                style={{
                  color: "white",
                  textShadow: "0px 1px black",
                  fontWeight: 100,
                  fontSize: 24,
                  
                }}
              >
                "This gives me more bandwidth at work. And because I can hang
                out with my kids and not be exhausted all the time, I’m able to
                be the kind of parent I’d always hoped to be."
              </p>
              <p
                style={{
                  color: "#CCCCCC",
                  textAlign: "center",
                  fontWeight: 100,
                  fontSize: 16
                }}
              >
                Gregory Gilbert, MD
              </p>
            </Card>
            <div className="col2" style={{ marginTop: "5%", maxWidth: "500px",padding:"0% 2% 0% 2%" }}>
              <p style={{ color: "#4BAF79", fontWeight: 500, fontSize: 20 }}>
                REDUCE EMPLOYEE STRESS AND IMPROVE MORALE{" "}
              </p>

              <p style={{ fontWeight: 100, fontSize: 18 }}>
                Because they'll spend less time juggling responsibilities,
                employees are free to pursue their passions at work and at home.
                A pilot among Stanford Med School faculty cut employee turnover
                to zero for the first time ever.
              </p>
            </div>
            {/* </Card>

          <Card
            style={{
              padding: "2% 2% 2% 2%",
              width: "80%",
              display: "flex",
              marginTop: "5%",
              borderRadius:"10px"
            }}
          > */}
            <div
              className="col3"
              style={{ maxWidth: "500px", marginTop: "15%",padding:"0% 2% 0% 2%" }}
            >
              <p style={{ color: "#4BAF79", fontWeight: 500, fontSize: 20 }}>
                LEARN WHERE YOUR TEAMMATES NEED MORE SUPPORT{" "}
              </p>

              <p style={{ fontWeight: 100, fontSize: 18 }}>
                We help you understand where your employees need the most help
                in their personal lives, so you can give them the support to thrive
                at work.
              </p>
            </div>
            <div
              className="col4"
              style={{
                marginTop: "0%",
                marginLeft: "15%",
                marginLeft: "0%",
                maxWidth: "400px",
                
              }}
            >
              <object
                data={Offer}
                type="image/svg+xml"
                style={{ width: "400px" }}
              />
            </div>{" "}
            {/* </Card>

          <Card
            style={{
              padding: "2% 2% 2% 2%",
              width: "80%",
              display: "flex",
              marginTop: "5%",
              borderRadius:"10px"
            }}
          > */}
            <div
              className="col5"
              style={{ marginTop: "0%", marginLeft: "0%", maxWidth: "400px"  }}
            >
              <object
                data={Rewards}
                type="image/svg+xml"
                style={{ width: "400px" }}
              />
            </div>{" "}
            <div className="col6" style={{ marginTop:"15%",maxWidth: "500px",padding:"0% 2% 0% 2%"}}>
              <p style={{ color: "#4BAF79", fontWeight: 500, fontSize: 20 }}>
                REWARD EMPLOYEES FOR BEING GOOD TEAMMATES{" "}
              </p>

              <p style={{ fontWeight: 100, fontSize: 18 }}>
                Recognition should be about more than just work. Give your
                employees tangible rewards for doing the little things in- and
                outside of the office that make a company tick.{" "}
              </p>
            </div>
            {/* <div
            className="cta-middle-row"
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
              fontFamily: "Raleway",
              backgroundColor: "#F5F5F5",
              paddingTop: "5%",
              paddingBottom: "5%"
            }}
          >
            <div className="col"
              style={{}}
            >
              <p style={{ width:"50%",color: "#5C626C", fontWeight: 500, fontSize: 40 }}>
                Try Kinder to retain top talent and offer benefits packages that
                match your employees' lives.
              </p>
              <EmailSignupBusiness  style={{width:"50%"}}/>

              
            </div>
          </div> */}
            <div
              className="col7"
              style={{  marginTop: "20%", maxWidth: "500px",padding:"0% 2% 0% 2%"}}
            >
              <p style={{ color: "#4BAF79", fontWeight: 500, fontSize: 28 }}>
                Build community within your organization{" "}
              </p>

              <p style={{ fontWeight: 100, fontSize: 18 }}>
                Kinder sparks conversations, relationships, knowledge exchange,
                and trust among employees of all levels. Even better, we help
                you visualize who's interacting and who isn't.
              </p>
            </div>
            <div
              className="col8"
              style={{ marginTop:"10%",marginLeft: "0%", maxWidth: "400px"}}
            >
              <object
                data={Chat}
                type="image/svg+xml"
                style={{ width: "400px" }}
              />
            </div>{" "}
            {/* </Card>
          <Card
            style={{
              padding: "2% 2% 2% 2%",
              width: "80%",
              display: "flex",
              marginTop: "5%",
              borderRadius:"10px"
            }}
          > */}
          </Card>
        </div>
        <div className="CTA-wrapper" style={{padding: "5% 2% 5% 2%"}}>
          <div className="CTA-col" style={{}}>
            <p style={{ color: "#CCCCCC", fontWeight: 500, fontSize:"40px" }}>
              Try Kinder to build a workplace founded on community and
              recognition.
            </p>
          </div>
          <div className="CTA-col2-wrap" style={{}}>
            <EmailSignupBusiness className="CTA-col2" style={{}} />
          </div>
        </div>
      </div>
    );
  }
}

export default Business;
